import React from 'react';

export const createElement = ({ tag, children, ...props }) =>
  children ? React.createElement(tag || 'div', { ...props, children }) : null;
export default createElement;
